import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";

const defaultSx = {
	"& .super-app-theme--header": {
		textTransform: "uppercase",
	},
};
function DisplayDataGrid({ columns, rows, columnWidth, sx = defaultSx, hideFooter, columnHeaderHeight = 35, rowHeight = 40 }) {
	columns = columns.map((col, index) => {
		return { id: index + 1, field: col, headerName: col?.split("_").join(" "), flex: 1, align: "center", headerAlign: "center", minWidth: 100 };
	});

	rows = rows.map((row, index) => {
		return { ...row, id: index + 1 };
	});

	columns = columns.map((col) => {
		return { ...col, headerClassName: "super-app-theme--header", width: columnWidth ? columnWidth : 130 };
	});

	return (
		<Box sx={{ height: 400, width: "100%" }}>
			<DataGrid
				sx={sx}
				rows={rows}
				columns={columns}
				initialState={
					hideFooter
						? {}
						: {
								pagination: {
									paginationModel: {
										pageSize: 50,
									},
								},
						  }
				}
				pageSizeOptions={[50, 100]}
				checkboxSelection={false}
				disableRowSelectionOnClick
				hideFooter={hideFooter}
				columnHeaderHeight={columnHeaderHeight}
				rowHeight={rowHeight}
				pagination={!hideFooter}
			/>
		</Box>
	);
}

export default DisplayDataGrid;
